module.exports = __webpack_public_path__ + "img/break_time.a1698fca.svg";